export default __webpack_public_path__ + "static/media/2.aca5dd6d.png";